module.exports = __webpack_public_path__ + "img/logo-youmay.eaf92294.svg";